import { connect } from 'react-redux';
import UserListView from './UserListView.jsx';
import { showSettingsSideMenu, hideSettingsSideMenu }
  from 'src/legacy/redux/actions/settings.jsx';
import { fetchAccountUsers, selectUser, fetchUserManagementUser, fetchUserManagementList, fetchUserGroupsForUser, invalidateUserGroups } from 'src/legacy/redux/actions/userManagement.jsx';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';


const mapStateToProps = (state, ownProps) => {
  return {
    loading: state.legacyRootReducer.settings.userManagement.loading,
    currentPage: state.legacyRootReducer.settings.userManagement.pagination.current,
    totalPages: state.legacyRootReducer.settings.userManagement.pagination.totalPages,
    users: state.legacyRootReducer.settings.userManagement.items,
    user: state.legacyRootReducer.settings.userManagement.users.user,
    showSettingsMenu: state.legacyRootReducer.settings.settingsMenu.showSettingsMenu
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchAccountUsers: (page, query) => {
      dispatch(fetchAccountUsers(page, query))
    },

    hideSettingsSideMenu: () => {
        dispatch(hideSettingsSideMenu())
    },

    selectUser: (user) => {
        return dispatch(selectUser(user))
    },
    fetchUserManagementUser: (userId) => {
      return dispatch(fetchUserManagementUser(userId))
    },
    fetchUserManagementList: (page, query, filter) => {
      dispatch(fetchUserManagementList(page, query, filter))
    },
    fetchUserGroupsForUser: (page, user) => {
      dispatch(fetchUserGroupsForUser(page, user))
    },
    invalidateUserGroups: () => {
      dispatch(invalidateUserGroups())
    }
  }
}

const UserListContainer = connect (
    mapStateToProps,
    mapDispatchToProps
)(UserListView);

export default withUseHooks(UserListContainer);